<template>
	<div class="button_container" v-bind:style="{'justify-content': align}">
		<a :href="link" :target="target" class="button_element" v-bind:style="{'color': color}">
			<font-awesome-icon v-if="picto && !pictoAfter" :icon="[pictoWeight, picto]"/>
			<span v-html="label"></span>
			<font-awesome-icon v-if="picto && pictoAfter" :icon="[pictoWeight, picto]"/>
		</a>
	</div>

</template>

<script>

import Vue2Filters from "vue2-filters";

export default {
	name: "Button",
	mixins: [Vue2Filters.mixin],
	components: {},
	data: function () {
		return {
			isOutline: (this.outline)
		};
	},
	props: {
		color: {
			type: String,
			default: "#000000"
		},
		label: {
			type: String,
			default: ""
		},
		link: {
			type: String,
			default: ""
		},
		target: {
			type: String,
			default: "_self"
		},
		picto: {
			type: String,
			default: ""
		},
		pictoWeight: {
			type: String,
			default: "far"
		},
		pictoAfter: {
			type: String,
			default: ""
		},
		align: {
			type: String,
			default: "flex-start"
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use '@/assets/scss/partials/variables' as *;
@use '@/assets/scss/partials/mixins' as *;

.button {
	&_container {
		display: flex;
		padding-top: 2rem;
		width: 100%;
	}

	&_element {
		align-items: center;
		border: 1px solid currentColor;
		color: currentColor;
		display: flex;
		flex-direction: row;
		font-size: 1.8rem;
		gap: 1rem;
		justify-content: center;
		padding: 1rem 2rem;
		transition: 0.25s;
		width: fit-content;

		&:hover {
			background-color: #000000 !important;
			border-color: #000000 !important;
			color: #FFFFFF !important;
			transition: 0.25s;
		}

		i {

		}
	}
}

</style>
